import { PlaybackOptions } from "../components/PlaybackOptionsPanel";
import { useDrillLocalStorage } from "./useDrillLocalStorage";

const DEFAULT_PLAYBACK_OPTIONS: PlaybackOptions = {
    instrument: "piano",
    volume: 80,
    muted: false,
    playMode: "melodic",
};

/**
 * Shared hook for persisting playback settings across all drills
 * Uses localStorage key "drill_playback_storage"
 *
 * @returns [playbackOptions, setPlaybackOptions, isLoaded] tuple
 */
export function usePlaybackSettings(): [PlaybackOptions, (options: PlaybackOptions | ((prev: PlaybackOptions) => PlaybackOptions)) => void, boolean] {
    return useDrillLocalStorage<PlaybackOptions>(
        "drill_playback_storage",
        DEFAULT_PLAYBACK_OPTIONS
    );
}
